import {NewReviewItemPageContent} from './new-review-item-page-content/new-review-item-page-content';
import {ReviewActivityProvider} from './review-activity-provider/review-activity-provider';
import {ReviewsStateProvider} from './reviews-state/reviews-state-provider';

export function ReviewsReviewItemRoute(): JSX.Element {
    return (
        <ReviewActivityProvider expandedReplies>
            <ReviewsStateProvider>
                <NewReviewItemPageContent />
            </ReviewsStateProvider>
        </ReviewActivityProvider>
    );
}
